<template>
  <div>
    <div
      :class="[
        selected ? 'selected' : '',
        noBorder ? '' : 'card card_white flex-fill',
      ]"
      style="margin-bottom: 12px; cursor: pointer"
      v-bind:style="height != null ? 'height: ' + height + 'px;' : ''"
    >
      <div class="sub_title_2">
        <span v-if="param.metricName != null">{{ param.metricName }}</span>
      </div>
      <div v-if="param.value != null" class="data_text">
        {{ formattedNumber(param.value) }} <span>{{ param.unit }}</span>
      </div>
      <div class="d-flex mt-2">
        <div
          v-if="achievement === true"
          class="d-inline-flex align-items-center me-2"
          :class="
            param.achievementStatus === 'UP'
              ? 'badge_green'
              : param.achievementStatus === 'DOWN'
              ? 'badge_red'
              : 'badge_black'
          "
        >
          <IconSvg
            v-if="param.achievement != null"
            :color="param.achievementStatus === 'UP' ? 'green' : 'red'"
            :type="param.achievementStatus === 'UP' ? 'arrow_up' : 'arrow_down'"
          />
          <span class="chart_up" v-if="param.achievement == null"> --- </span>
          <div
            class="data_detil"
            v-bind:style="
              param.achievementStatus === 'UP'
                ? 'color: green;'
                : param.achievementStatus === 'DOWN'
                ? 'color: red;'
                : 'color: black;'
            "
          >
            {{ param.achievement != null ? param.achievement : "0%" }}
          </div>
        </div>
        <div
          v-if="trend === true"
          class="d-inline-flex align-items-center"
          :class="
            param.trendStatus === 'UP'
              ? 'badge_green'
              : param.trendStatus === 'DOWN'
              ? 'badge_red'
              : 'badge_black'
          "
        >
          <IconSvg
            v-if="param.trend != null"
            :color="param.trendStatus === 'UP' ? 'green' : 'red'"
            :type="param.trendStatus === 'UP' ? 'chart_up' : 'chart_down'"
          />
          <span class="chart_up" v-if="param.trend == null"> --- </span>
          <div
            class="data_detil"
            v-bind:style="
              param.trendStatus === 'UP'
                ? 'color: green;'
                : param.trendStatus === 'DOWN'
                ? 'color: red;'
                : 'color: black;'
            "
          >
            {{ param.trend != null ? param.trend : "0%" }}
          </div>
        </div>
      </div>
      <div v-if="chart" style="position: absolute; bottom: 0; right: 0;">
        <img
          @click="showGraph"
          style="cursor: pointer"
          src="@/assets/images/a/chart_icon.svg"
        />
      </div>
    </div>
  </div>
</template>

<script>
import IconSvg from "@/components/IconSvg.vue";
import { formattedNumber } from "@/utils/helper";

export default {
  components: {
    IconSvg,
  },
  props: {
    param: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      required: false,
    },
    noBorder: {
      type: Boolean,
      required: false,
    },
    selected: {
      type: Boolean,
      required: true,
    },
    achievement: {
      type: Boolean,
      required: false,
    },
    trend: {
      type: Boolean,
      required: false,
    },
    chart: {
      type: Boolean,
      required: false,
    },
  },

  mounted() {},
  watch: {
    selected: function (newVal, oldVal) {
      // watch it
    },
  },

  methods: {
    showGraph() {
      this.$emit("showGraph");
    },
    formattedNumber,
  },
};
</script>
<style scoped>
.selected {
  background-color: #ecf9ff;
  border: 1px solid #00a3e9;
}
</style>
